<!-- Translation Loading Overlay -->
<div *ngIf="translationsLoading" class="translation-loader-overlay">
  <div class="translation-loader-content">
    <p-progressSpinner strokeWidth="4" fill="var(--surface-ground)" animationDuration=".5s"></p-progressSpinner>
    <p class="mt-3 text-muted">Loading translations...</p>
  </div>
</div>

<div *ngIf="!translationsLoading" class="d-flex justify-content-center align-items-center vh-100">
  <div class="bg-white p-4 login-div">
    <div class="d-flex align-items-center gap-2 mt-4" [ngClass]="{'justify-content-between': printTemplate === 'aucc' || printTemplate === 'modern', 'justify-content-center': printTemplate !== 'aucc' && printTemplate !== 'modern'}">
      <img src="../../../assets/logo.png" alt="medworklogo" width="150px" height="50px"/>
      <img *ngIf="printTemplate === 'aucc'" src="../../assets/healthbe-logo.jpeg"
      alt="dental-form-logo" width="150px" height="50px"/>
      <img src="../../assets/methaqins-logo.jpeg" alt="" *ngIf="printTemplate === 'modern'" width="150px" />
    </div>

    <!-- for testbe -->
     <!-- <div class="d-flex align-items-center justify-content-center gap-2 mt-4" >
      <img src="../../../assets/logo.png" alt="medworklogo" width="150px" height="50px"/>  
    </div> -->
    <div class="d-flex justify-content-center mt-4 language-switcher">
      <p-dropdown [options]="languages" [(ngModel)]="selectedLanguage" (onChange)="changeLanguage($event.value)"
        optionLabel="name" optionValue="code" class="w-full">
        <ng-template let-lang pTemplate="selectedItem">
          <div class="d-flex align-items-center gap-2">
            <img [src]="getFlag(lang?.code)" class="mr-2" />
            <span [ngStyle]="{'font-family': lang?.code === 'ar' ? 'Noto Kufi Arabic, sans-serif' : 'inherit'}">{{
              lang?.name }}</span>
          </div>
        </ng-template>
        <ng-template let-lang pTemplate="item">
          <div class="d-flex align-items-center gap-2">
            <img [src]="getFlag(lang?.code)" class="mr-2" />
            <span [ngStyle]="{'font-family': lang?.code === 'ar' ? 'Noto Kufi Arabic, sans-serif' : 'inherit'}">{{
              lang?.name }}</span>
          </div>
        </ng-template>
      </p-dropdown>
    </div>
    <form #loginForm="ngForm" (ngSubmit)="Onlogin(loginForm)">
      <div class="d-flex flex-column gap-2 mt-5">
        <input pInputText id="username" name="username" #usernameCtrl="ngModel" required [(ngModel)]="username"
          aria-describedby="username-help" [placeholder]="'enterusername' | translate"
          [ngClass]="{'ng-dirty': usernameCtrl.dirty || usernameCtrl.touched, 'is-invalid': usernameCtrl.invalid && (usernameCtrl.dirty || usernameCtrl.touched)}" />
        <div *ngIf="usernameCtrl.invalid && (usernameCtrl.dirty || usernameCtrl.touched)" class="text-danger">
          {{ 'username_required' | translate }}
        </div>
      </div>
      <div class="d-flex flex-column gap-2 mt-4">
        <p-password name="password" #passwordCtrl="ngModel" required [(ngModel)]="password" [toggleMask]="true"
          [placeholder]="'enterpassword' | translate" [feedback]="false"
          [ngClass]="{'ng-dirty': passwordCtrl.dirty || passwordCtrl.touched, 'is-invalid': passwordCtrl.invalid && (passwordCtrl.dirty || passwordCtrl.touched)}">
        </p-password>
        <div *ngIf="passwordCtrl.invalid && (passwordCtrl.dirty || passwordCtrl.touched)" class="text-danger">
          {{ 'password_required' | translate }}
        </div>
      </div>
      <div class="d-flex gap-2 align-items-centerr my-3">
        <p-checkbox [(ngModel)]="rememberme" binary="true" name="rememberme" inputId="Remember me" />
        <label for="Remember me">{{'Remember me' | translate}}</label>
      </div>
      <div class="d-flex justify-content-end text-muted fs-6">
        <div class="text-end">
          <div>Version {{appVersion}}</div>
        </div>
      </div>
      <div class="d-flex flex-column gap-2 mt-4 signin-div">
        <p-button class="mybutton" type="submit">
          <ng-template pTemplate="content">
            <div class="button-content">
              <mat-spinner *ngIf="isLoading" diameter="30" class="spinner"></mat-spinner>
              <span *ngIf="!isLoading">{{ 'signin' | translate }}</span>
            </div>
          </ng-template>
        </p-button>
      </div>
    </form>
    <div class="d-flex justify-content-center mt-4">
      <button class="btn shadow-0 border-0 outline-0 text-muted">{{'forgotpassword?' | translate}}</button>
    </div>
  </div>
</div>